export default class Rim {

    constructor(data) {
        this.id = null;
        this.name = null;
        this.state = null;
        this.note = null;

        if (data) {
            Object.assign(this, data);
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/rim.model.js